<template>
  <div>
    <h3 class="text-xl mb-6">Register Users / Course</h3>
    <table v-if="registrants.length > 0" class="w-full leading-normal">
      <tbody v-for="(registrant, i) in registrants" :key="i" class="border-b" :class="i == registrants.length - 1 ? 'border-transparent' : 'border-grey-light'">
        <tr><td colspan="2" class="align-top text-sm font-bold pt-4">{{ registrant.first_name + ' ' + registrant.last_name }}</td></tr>
        <tr><td colspan="2" class="align-top text-sm">{{ registrant.email }}</td></tr>
        <tr>
          <td class="align-top text-sm pb-3 pr-3">{{ registrant.course_name }}</td>
          <td class="align-bottom text-right pb-3 text-sm">{{ '£' + parseFloat(registrant.course_fee).toFixed(2) }}</td>
        </tr>
      </tbody>
    </table>
    <p v-else>Please fill out registrant details under the 'Your Details' and 'Additional Users' sections.</p>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: ['registrants']
}
</script>
